import React from 'react';
import { composer } from '../../component-decorators/composer';
import s from './empty-state.scss';
import { Divider, Text } from 'wix-style-react';
export var EmptyStateDivider = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement("div", { className: s.emptyStateDivider },
        React.createElement("div", { className: s.dividerWrapper },
            React.createElement(Divider, null)),
        React.createElement(Text, { className: s.emptyStateText, secondary: true }, t('manage-apps.empty-state.divider')),
        React.createElement("div", { className: s.dividerWrapper },
            React.createElement(Divider, null))));
});
//# sourceMappingURL=empty-state-divider.js.map